import { Block } from '@components/core-ui/Block';
import styled from 'styled-components';

export const StyledBlock = styled(Block)`
  .invite {
    padding: 5px 0 10px;
    border: none;
    background: none;
    color: var(--color-link);
    font-size: 12px;
    font-weight: 500;
    line-height: 18px;
    text-decoration-line: underline;

    &:hover {
      color: var(--color-text-muted);
    }
  }
`;
